/* CGL product reviews: sort and "Show more" for sections/cgl-product-reviews.liquid.
   Without this script every review is visible in newest-first order. */
(function () {
  if (customElements.get('cgl-review-list')) return;

  class CglReviewList extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-review-list]');
      if (!this.list) return;
      this.items = Array.from(this.list.children);
      this.perPage = parseInt(this.dataset.perPage, 10) || 5;
      this.shown = this.perPage;
      this.sort = this.querySelector('[data-review-sort]');
      this.moreWrap = this.querySelector('[data-review-more-wrap]');
      this.more = this.querySelector('[data-review-more]');
      this.status = this.querySelector('[data-review-status]');
      const tools = this.querySelector('[data-review-tools]');
      if (tools) tools.hidden = false;
      if (this.sort) this.sort.addEventListener('change', () => this.order());
      if (this.more) this.more.addEventListener('click', () => this.showMore());
      this.render();
    }

    order() {
      const by = this.sort.value;
      const num = (el, key) => parseFloat(el.dataset[key]) || 0;
      this.items.sort((a, b) => {
        if (by === 'highest') return num(b, 'rating') - num(a, 'rating') || num(b, 'date') - num(a, 'date');
        if (by === 'lowest') return num(a, 'rating') - num(b, 'rating') || num(b, 'date') - num(a, 'date');
        return num(a, 'index') - num(b, 'index');
      });
      this.items.forEach((el) => this.list.appendChild(el));
      this.shown = this.perPage;
      this.render();
    }

    showMore() {
      const firstNew = this.items[this.shown];
      this.shown += this.perPage;
      this.render();
      // Move focus to the first newly shown review so keyboard and screen reader users continue from there.
      const heading = firstNew && firstNew.querySelector('h3');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: false });
      }
    }

    render() {
      const total = this.items.length;
      this.items.forEach((el, i) => { el.hidden = i >= this.shown; });
      if (!this.moreWrap) return;
      const visible = Math.min(this.shown, total);
      this.moreWrap.hidden = visible >= total;
      if (this.status) {
        this.status.textContent = (this.status.dataset.template || 'Showing [shown] of [total]')
          .replace('[shown]', visible).replace('[total]', total);
      }
    }
  }

  customElements.define('cgl-review-list', CglReviewList);
})();
